var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classNames from "classnames";
var Tuile = function (_a) {
    var titre = _a.titre, description = _a.description, ComponentLink = _a.linkAs, ComponentTitre = _a.titreAs, isHorizontal = _a.isHorizontal, image = _a.image, alignementMd = _a.alignementMd, hasBackgroundGris = _a.hasBackgroundGris, className = _a.className, classNameTitre = _a.classNameTitre, classNameDescription = _a.classNameDescription, otherProps = __rest(_a, ["titre", "description", "linkAs", "titreAs", "isHorizontal", "image", "alignementMd", "hasBackgroundGris", "className", "classNameTitre", "classNameDescription"]);
    if (!ComponentLink) {
        ComponentLink = 'a';
    }
    if (!ComponentTitre) {
        ComponentTitre = 'h4';
    }
    var classTuile = "fr-tile fr-enlarge-link";
    if (isHorizontal) {
        classTuile += " fr-tile--horizontal";
    }
    if (alignementMd) {
        classTuile += " fr-tile--" + alignementMd + "-md";
    }
    if (hasBackgroundGris) {
        classTuile += " fr-tile--grey";
    }
    return (React.createElement("div", { className: classNames(classTuile, className) },
        React.createElement("div", { className: "fr-tile__body" },
            React.createElement(ComponentTitre, { className: classNames("fr-tile__title", classNameTitre) },
                React.createElement(ComponentLink, __assign({ className: "fr-tile__link" }, otherProps), titre)),
            React.createElement("p", { className: classNames("fr-tile__desc", classNameDescription) }, description)),
        image ? (React.createElement("div", { className: "fr-tile__img" },
            React.createElement("img", { src: image, className: "fr-responsive-img", alt: "" }))) : null));
};
Tuile.defaultProps = {
    linkAs: 'a',
    titreAs: 'h4'
};
export default Tuile;
